<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useStore } from '@composables/use-store'

// Going back two entries: one for the page being left, one for the entry the
// router is about to push on top of it.
const HISTORY_STEPS_CONSUMED = 2

const store = useStore()
const router = useRouter()

const historyLength = computed(() => store.state.status.historyLength)

const isVisible = computed(() => historyLength.value > 1)

function goBack() {
    router.go(-1)
    store.commit('status/SET_HISTORY_LENGTH', historyLength.value - HISTORY_STEPS_CONSUMED)
}
</script>

<template>
    <a
        :class="['back-arrow', isVisible && 'back-arrow-visible']"
        @click="goBack"
    >
        <BaseIcon
            class="arrow"
            name="arrow-longer-left"
        />
    </a>
</template>

<style lang="scss" scoped>
@import '@design';

.back-arrow {
    z-index: $layer-overlay-z-index;
    visibility: hidden;
    cursor: pointer;

    &-visible {
        visibility: visible;
    }
}

.arrow {
    width: $s-m;
    height: $s-xl;
    fill: $c-white;
}
</style>
